import { LocalService } from './../../../../services/storage/localService';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { DatePipe, DecimalPipe } from '@angular/common';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { SimuladoresDetalle } from '../../../../models/SimuladoresDetalle';
import * as moment from 'moment';
import { MessagesGeneral, MessagesDates, MessagesTitles, MessagesSimuladorAgregarDetalle } from '../../../../models/messages';
import { ErrorModel } from '../../../../models/ErrorModel';

export const MY_FORMATS  ={
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-insertar-simulador-detalle',
  templateUrl: './insertar-simulador-detalle.component.html',
  styleUrls: ['./insertar-simulador-detalle.component.scss'],
  providers: [
    DatePipe,
    DecimalPipe,MessagesTitles,MessagesGeneral,MessagesDates,MessagesSimuladorAgregarDetalle,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class InsertarSimuladorDetalleComponent implements OnInit {

  @Output() cerrarsimuladorDetalle: EventEmitter<boolean>;
  @Output() itemSimuladorDetalle = new EventEmitter();
  @Input() fechaDesembolso :any;
  SimuladorDetalle: SimuladoresDetalle ;
  IGV = false;
  MILISENGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;
  errorFecha = new ErrorModel() ;
  errorVNPP= new ErrorModel() ;
  retencionBaseElement : any;
  fondoGarantiaBaseElement : any;

  readonly varDiasMin = this.localService.getJsonValue('ParametroRechazoMin');
  readonly varDiasMax = this.localService.getJsonValue('ParametroRechazoMax');

  constructor(  private decimalPipe: DecimalPipe,
    private msgAgregarSimulador : MessagesSimuladorAgregarDetalle,
    private localService : LocalService) {

    this.cerrarsimuladorDetalle = new EventEmitter();
    this.SimuladorDetalle = new SimuladoresDetalle();
   }

  ngOnInit() {
    this.SimuladorDetalle.IGV_Factura_Porcentaje = this.localService.getJsonValue('ParametroIGVPorcentaje');
    let now = moment(this.fechaDesembolso._d).add(35,'days');
    this.SimuladorDetalle.Fecha_de_Pago = now;
    this.calcularDiferenciaDias();
    this.retencionBaseElement = 72;
    this.fondoGarantiaBaseElement = 72;
  }

  RetencionBase(event){
    this.SimuladorDetalle.Retencion_Base = event;
    this.calcularVNPP();
    this.tranformarDecimal('VNPP');
  }
  FondoGarantiaBase(event){
    this.SimuladorDetalle.Fondo_Garantia_Base = event;
    this.calcularVNPP();
    this.tranformarDecimal('VNPP');
  }
  

  calcularDiferenciaDias(){    
    this.SimuladorDetalle.Plazo = this.diferenciaEntreDiasEnDias(this.SimuladorDetalle.Fecha_de_Pago['_d'],this.fechaDesembolso['_d']);
  }

  MetcerrarSimuladorDetalle(){

    this.cerrarsimuladorDetalle.emit();
  }

  EnviarItemSimuladorDetalle(){
    this.errorFecha = new ErrorModel() ;
    this.errorVNPP= new ErrorModel() ;

    if (this.SimuladorDetalle.Plazo < this.varDiasMin ||this.SimuladorDetalle.Plazo > this.varDiasMax ){

      this.errorFecha.State_Error = true;
      this.errorFecha.Msg_Error = this.msgAgregarSimulador.Error_Plazo_Dias;
      return;
    }


    if (this.cortarComa(this.SimuladorDetalle.VNPP) < String(30)){

      this.errorVNPP.State_Error = true;
      this.errorVNPP.Msg_Error = this.msgAgregarSimulador.Error_VNPP_Invalido;
      return;
    }

    this.SimuladorDetalle.Detraccion_Porcentaje = this.SimuladorDetalle.Detraccion_Porcentaje/100;
    this.SimuladorDetalle.Fondo_Garantia_Porcentaje = this.SimuladorDetalle.Fondo_Garantia_Porcentaje/100;
    this.SimuladorDetalle.Retencion_Porcentaje = this.SimuladorDetalle.Retencion_Porcentaje/100;
    this.SimuladorDetalle.VNPP = this.cortarComa(this.SimuladorDetalle.VNPP);
    this.SimuladorDetalle.IGV_Factura_Importe = this.cortarComa(this.SimuladorDetalle.IGV_Factura_Importe);
    this.SimuladorDetalle.Otros_Descuentos = this.cortarComa(this.SimuladorDetalle.Otros_Descuentos);
    this.SimuladorDetalle.Precio_Venta = this.cortarComa(this.SimuladorDetalle.Precio_Venta);
    this.SimuladorDetalle.Valor_Venta = this.cortarComa(this.SimuladorDetalle.Valor_Venta);
    
    this.itemSimuladorDetalle.emit(this. SimuladorDetalle);
  }

  diferenciaEntreDiasEnDias(a, b) {
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return  Math.floor((utc1 - utc2) / this.MILISENGUNDOS_POR_DIA);
  }

  deshabilitarIGV() {
   

    let precioVenta = this.cortarComa(this.SimuladorDetalle["Precio_Venta"]);
    let valorVenta = precioVenta/1.18;
    let IGV = precioVenta - valorVenta;


    if (!this.IGV){
      this.SimuladorDetalle["IGV_Factura_Importe"] = '0.00';
      this.SimuladorDetalle["Valor_Venta"] = precioVenta.toFixed(2);
    }else{

      this.SimuladorDetalle["IGV_Factura_Importe"] = IGV.toFixed(2);
      this.SimuladorDetalle["Valor_Venta"] = valorVenta.toFixed(2);
    }
    

  }

  calcularVNPP(){

    let otrosDescuentos = Number(this.cortarComa(this.SimuladorDetalle.Otros_Descuentos));

    let valorVenta = Number(this.cortarComa(this.SimuladorDetalle.Valor_Venta));
    let precioVenta = Number(this.cortarComa(this.SimuladorDetalle.Precio_Venta));
    let detraccion = Number(this.SimuladorDetalle.Detraccion_Porcentaje);  
    let importeDetraccion = Number((detraccion/100)* precioVenta);  
    this.SimuladorDetalle.Detraccion_Importe = importeDetraccion;
    let VNPP  = 0;
    let retencion = 0;
    let importeRetencion = 0;
    let fondoGarantia = 0;
    let importeFondoGarantia =0;    
    if (this.SimuladorDetalle.Retencion_Base === 71){
     retencion = Number(this.SimuladorDetalle.Retencion_Porcentaje);
     importeRetencion = Number((retencion/100)*precioVenta);
     this.SimuladorDetalle.Retencion_Importe = importeRetencion;
    }else {
      retencion = Number(this.SimuladorDetalle.Retencion_Porcentaje);
      importeRetencion = Number((retencion/100)*valorVenta);
      this.SimuladorDetalle.Retencion_Importe = importeRetencion;
    }

    if (this.SimuladorDetalle.Fondo_Garantia_Base === 71){
      fondoGarantia = Number(this.SimuladorDetalle.Fondo_Garantia_Porcentaje);
      importeFondoGarantia = Number((fondoGarantia/100) * precioVenta);
      this.SimuladorDetalle.Fondo_Garantia_Importe = importeFondoGarantia;
     }else{      
      fondoGarantia = Number(this.SimuladorDetalle.Fondo_Garantia_Porcentaje);
      importeFondoGarantia = Number((fondoGarantia/100) * valorVenta);
      this.SimuladorDetalle.Fondo_Garantia_Importe = importeFondoGarantia;
     }
     VNPP = Number(precioVenta) - Number(importeDetraccion +  importeRetencion + importeFondoGarantia + otrosDescuentos);
     this.SimuladorDetalle.VNPP = VNPP.toFixed(2);
  }

  agregarDatosTranformados(){
    let otrosDescuentos = Number(this.cortarComa(this.SimuladorDetalle.Otros_Descuentos));
    let valorVenta = Number(this.cortarComa(this.SimuladorDetalle.Valor_Venta));
    let precioVenta = Number(this.cortarComa(this.SimuladorDetalle.Precio_Venta));
    let detraccion = Number(this.SimuladorDetalle.Detraccion_Porcentaje);
    let importeDetraccion = Number((detraccion/100)* precioVenta);  
    this.SimuladorDetalle.Detraccion_Importe = importeDetraccion;
    let VNPP  = 0;
    let retencion = 0;
    let importeRetencion = 0;
    let fondoGarantia = 0;
    let importeFondoGarantia =0;    
    if (this.SimuladorDetalle.Retencion_Base === 71){
     retencion = Number(this.SimuladorDetalle.Retencion_Porcentaje);
     importeRetencion = Number((retencion/100)*precioVenta);
     this.SimuladorDetalle.Retencion_Porcentaje = retencion/100;
     this.SimuladorDetalle.Retencion_Importe = importeRetencion;
    }else {
      retencion = Number(this.SimuladorDetalle.Retencion_Porcentaje);
      importeRetencion = Number((retencion/100)*valorVenta);
      this.SimuladorDetalle.Retencion_Porcentaje = retencion/100;
      this.SimuladorDetalle.Retencion_Importe = importeRetencion;
    }
    if (this.SimuladorDetalle.Fondo_Garantia_Base === 71){
      fondoGarantia = Number(this.SimuladorDetalle.Fondo_Garantia_Porcentaje);
      importeFondoGarantia = Number((fondoGarantia/100) * precioVenta);
      this.SimuladorDetalle.Fondo_Garantia_Porcentaje = fondoGarantia/100;
      this.SimuladorDetalle.Fondo_Garantia_Importe = importeFondoGarantia;
     }else{      
      fondoGarantia = Number(this.SimuladorDetalle.Fondo_Garantia_Porcentaje);
      importeFondoGarantia = Number((fondoGarantia/100) * valorVenta);
      this.SimuladorDetalle.Fondo_Garantia_Porcentaje = fondoGarantia/100;
      this.SimuladorDetalle.Fondo_Garantia_Importe = importeFondoGarantia;
     }
     VNPP = Number(valorVenta) - Number(importeDetraccion +  importeRetencion + importeFondoGarantia + otrosDescuentos);
     this.SimuladorDetalle.VNPP = VNPP.toFixed(2);
  }

  tranformarDecimal(control: any, decimal?: number) {
    let valor;
      valor =  this.decimalPipe.transform(this.cortarComa(this.SimuladorDetalle[`${control}`]), `1.2-2` );
      this.SimuladorDetalle[`${control}`] = valor;   
  }

  cortarComa(numero: any): any {
    try {
      let cortado = numero.toString().replace(/,/gi, "");
      return Number(cortado);
    } catch (error) {
      return 0;
    }
  }  
}
